import React from 'react';
import Tab from '../../Components/Tab/Tab';
import './Index.scss';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const routeList = {
    '/history/order-history': '배달/포장',
    '/history/pickup-order-history': '픽업오더',
    '/history/table-order-history': '테이블오더',
    '/history/sms-history' : '문자',
    '/history/coupon-history' : '쿠폰',
    '/history/point-history' : '포인트',
    '/history/bell-history' : '벨',
    '/history/jungsan-history' : '정산',
    '/history/commerce-history' : '커머스쿠폰',
}

const History = (props) => {
    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();
    
    const tabRoute = [
        { route : 'order-history', header : '배달/포장' },
        { route : 'pickup-order-history', header : '픽업오더' },
        { route : 'table-order-history', header : '테이블오더' },
        { route : 'sms-history', header : '문자' },
        { route : 'coupon-history', header : '쿠폰' },
        { route : 'point-history', header : '포인트' },
        { route : 'bell-history', header : '벨' },
        { route : 'jungsan-history', header : '정산' },
        { route : 'commerce-history', header : '커머스쿠폰' },
        { route : 'waiting-history', header : '웨이팅' },
    ]

    return (
        <div className='wrapper'>
            <div className='header-row' style={{ marginLeft : 20 }}>
                <p className='header-text'>내역 {'>'}</p>
                <p className='header'>{routeList[route]}</p>
            </div>
            
            <Tab 
                headerStyle={{ marginLeft : 20 }}
                routes={tabRoute}
                current={route.replace('/history/','')}
                onTabChange={(name) => {navigate(`/history/${name}`)}}
                renderItems={{
                    'table-order-history' : <Outlet/>,
                    'pickup-order-history' : <Outlet/>,
                    'order-history' : <Outlet/>,
                    'sms-history' : <Outlet/>,
                    'coupon-history' : <Outlet/>,
                    'point-history' : <Outlet/>,
                    'bell-history' : <Outlet/>,
                    'jungsan-history' : <Outlet/>,
                    'commerce-history' : <Outlet/>,
                    'waiting-history' : <Outlet/>,
                }}
            />
        </div>
    )
}

export default History;